import axios from 'axios'

const baseURL = 'https://api.y2services.com'

const api = axios.create({
  baseURL,
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default api
